// packages/sdk/src/engine/SessionManager.ts

const PREFIX = 'msw_';

export class SessionManager {
  private projectId: string;

  constructor(projectId: string) {
    this.projectId = projectId;
  }

  private key(suffix: string): string {
    return `${PREFIX}${this.projectId}_${suffix}`;
  }

  hasShownBefore(): boolean {
    try {
      return localStorage.getItem(this.key('shown')) === '1';
    } catch {
      return false;
    }
  }

  markShown(): void {
    try {
      localStorage.setItem(this.key('shown'), '1');
    } catch {}
  }

  clearShown(): void {
    try {
      localStorage.removeItem(this.key('shown'));
    } catch {}
  }
}